import { makeStyles } from '@material-ui/core/styles'

// TODO Make these colors match properly instead of hardcoded
export const globalAlertStyles = makeStyles((theme) => ({
  dialog: {
    width: '70vw',
    maxWidth: '100%',
    height: '70vh',
    maxHeight: '450px',
    overflow: 'hidden',
    padding: '8px 12px',
    backgroundColor: theme.palette.backgroundColor.secondary,
    position: 'relative',
  },
  dialogContainer: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  mainDialog: {
    maxWidth: '100vw',
  },
  buttonWidth: {
    width: '100%',
  },
  alertTitle: {
    color: theme.palette.base.rutgersRed,
  },
  alertBody: {
    marginTop: '20px',
  },
  alertFooter: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    paddingRight: '22px',
  },
}))

export default globalAlertStyles
